module.exports = __webpack_public_path__ + "img/home-icon.264f7222.svg";